"use client"

import { Button } from "@/components/ui/button"
import {
   Form,
   FormControl,
   FormField,
   FormItem,
   FormLabel,
   FormMessage,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { authClient } from "@/lib/auth-client"

import { zodResolver } from "@hookform/resolvers/zod"
import { useState } from "react"
import { useForm } from "react-hook-form"
import { toast } from "sonner"
import { z } from "zod"

const schema = z.object({
   email: z.string().email({ message: "Adresse e-mail invalide" }),
})

export default function ForgotPasswordForm() {
   const [sent, setSent] = useState(false)
   const form = useForm<z.infer<typeof schema>>({
      resolver: zodResolver(schema),
      defaultValues: { email: "" },
   })

   async function onSubmit({ email }: z.infer<typeof schema>) {
      await authClient.requestPasswordReset(
         { email, redirectTo: "/reset-password" },
         {
            onRequest: () => {
               toast.loading("Envoi en cours…")
            },
            onResponse: () => {
               toast.dismiss()
            },
            // On affiche le même message que la demande ait abouti ou non :
            // ne pas révéler si une adresse a un compte (énumération de comptes).
            onSuccess: () => {
               setSent(true)
            },
            onError: () => {
               setSent(true)
            },
         },
      )
   }

   if (sent) {
      return (
         <p className="text-sm text-muted-foreground">
            Si un compte est associé à cette adresse, tu vas recevoir un e-mail
            avec un lien pour choisir un nouveau mot de passe. Pense à vérifier
            tes spams.
         </p>
      )
   }

   return (
      <Form {...form}>
         <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
            <FormField
               control={form.control}
               name="email"
               render={({ field }) => (
                  <FormItem>
                     <FormLabel>Adresse e-mail</FormLabel>
                     <FormControl>
                        <Input placeholder="prenom@exemple.fr" {...field} />
                     </FormControl>
                     <FormMessage />
                  </FormItem>
               )}
            />
            <Button type="submit" className="w-full" disabled={form.formState.isSubmitting}>
               Envoyer le lien
            </Button>
         </form>
      </Form>
   )
}
